import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendIncome } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendIncomeState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendIncomeInitialState: JobRecommendListForTrendIncomeState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendIncomeSlice = createSlice({
  name: 'jobRecommendListForTrendIncome',
  initialState: jobRecommendListForTrendIncomeInitialState,
  reducers: {
    setInitialDisplayFlagIncome: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendIncome.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(getJobListForTrendIncome.fulfilled, (state, action) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
      state.jobRecommendListForTrend.entity = action.payload;
    });
    builder.addCase(getJobListForTrendIncome.rejected, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Create Action
export const { setInitialDisplayFlagIncome } =
  jobRecommendListForTrendIncomeSlice.actions;

// reducer
export const jobRecommendListForTrendIncomeReducer =
  jobRecommendListForTrendIncomeSlice.reducer;

interface State {
  jobRecommendListForTrendIncome: JobRecommendListForTrendIncomeState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendIncomeLoadingSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendIncome?.jobRecommendListForTrend.loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendIncomeEntitySelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendIncome?.jobRecommendListForTrend.entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagIncomeSelector = <S extends State>(state: S) =>
  state.jobRecommendListForTrendIncome.initialDisplayFlag;
